export { default } from "./PhasesMspa";
